import { Injectable } from '@angular/core';
import { IGlobals } from '@overa/shared';
import { User } from '@overa/security';

@Injectable({
  providedIn: 'root',
})
export class BackofficeGlobals implements IGlobals {
  user: User = new User();
  cache: { [key: string]: unknown } = {};
}
